import { graphql } from 'relay-runtime';
import { useLazyLoadQuery } from 'react-relay';
import { useToken } from '../../../../Flow/ConsentContextProvider';
import { getUserWorkspaceAccessSummaryQuery } from '#generated/graphql/getUserWorkspaceAccessSummaryQuery.graphql';

export const useUserWorkspaceAccessSummary = () => {
  const { resources } = useToken();
  const resource = resources?.at(0);
  const response = useLazyLoadQuery<getUserWorkspaceAccessSummaryQuery>(
    query,
    // We'll skip this query if there's no workspace so it's safe to assume this is a string
    { workspaceAri: resource as string, shouldSkip: !resource },
    { fetchKey: resource },
  );
  const workspaceSummary = response.trello?.userWorkspaceAccessSummary;
  return {
    displayName: workspaceSummary?.displayName ?? '',
    displayBoardCount: workspaceSummary?.displayBoardCount ?? 0,
  };
};

const query = graphql`
query getUserWorkspaceAccessSummaryQuery(
    $workspaceAri: ID!
    $shouldSkip: Boolean!
  ) {
    trello {
      userWorkspaceAccessSummary(workspaceId: $workspaceAri) @optIn(to: "TrelloUserWorkspaceAccessSummary") @skip(if: $shouldSkip) {
        id
        displayName
        displayBoardCount
      }
    }
}`;
